import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Link } from './Link';
import './Logo.scss';

const storeBadgesQuery = graphql`
  query {
    settings: prismicSiteSett {
      data {
        logo {
          url
        }
        site_name {
          text
        }
      }
    }
  }
`;

export const Logo = () => (
  <StaticQuery
    query={storeBadgesQuery}
    render={({ settings }) => {
      const { logo, site_name: siteName } = settings.data;
      return (
        <Link className="logo" to="/">
          <img src={logo ? logo.url : ''} alt={siteName ? siteName.text : 'EatClub'} />
        </Link>
      );
    }}
  />
);
